import {
  Directive,
  HostBinding,
  Input,
  AfterViewInit,
  ElementRef,
  HostListener,
  SimpleChanges,
  OnChanges,
  Output,
  EventEmitter,
} from '@angular/core';
import { BreakpointService } from 'app/core/services/breakpoint.service';

@Directive({
  selector: 'img[ftsPicture]',
  exportAs: 'pictureRef',
})
export class PictureDirective implements AfterViewInit, OnChanges {
  @Input()
  imgSrc: string;
  @Input()
  imgSrcset: string;
  @Output()
  pictureSet: EventEmitter<void> = new EventEmitter();
  @Input()
  skipLazyLoading: boolean;
  @Input()
  prioritizeLoading: boolean;
  @Input()
  isFeatureItem: boolean;
  @Input()
  imgName: string;

  isLoaded = false;
  private imgsrc?: string;
  private imgsrcset?: string;
  isMobile = false;

  constructor(private el: ElementRef, private breakPointService: BreakpointService) {
    this.breakPointService.isTabletDown$.subscribe(isMobile => (this.isMobile = isMobile));
  }

  ngOnChanges(changes: SimpleChanges) {
    if (
      ((changes['skipLazyLoading'] && this.skipLazyLoading) || (changes['prioritizeLoading'] && this.prioritizeLoading)) &&
      !this.isLoaded
    ) {
      this.setPicture();
    }
    if (changes['imgSrc']) {
      this.setPicture();
    }
  }

  @HostBinding('src')
  public get src() {
    return this.imgSrc ? this.imgsrc : '';
  }

  @HostBinding('srcset')
  public get srcset() {
    return this.imgSrcset ? this.imgsrcset : '';
  }

  @HostBinding('attr.fetchpriority')
  public get fetchPriority() {
    return this.prioritizeLoading ? 'high' : null;
  }

  @HostListener('load', ['$event'])
  onLoad(event) {
    this.isLoaded = true;
  }

  setPicture(): void {
    if (this.isFeatureItem) {
      const mobileSrcsetImage = this.imgSrcset?.split(', ').find(srcSetPic => srcSetPic.includes(' mobile'));
      if (!!mobileSrcsetImage) {
        if (this.isMobile) {
          this.imgsrc = mobileSrcsetImage.substring(0, mobileSrcsetImage.lastIndexOf(' '));
        } else {
          this.imgsrc = this.imgSrc;
        }
        this.imgsrcset = '';
      } else {
        this.imgsrc = this.imgSrc;
        this.imgsrcset = this.imgSrcset;
      }
    } else {
      this.imgsrc = this.imgSrc;
      this.imgsrcset = this.imgSrcset;
      this.pictureSet.emit();
    }
  }

  ngAfterViewInit() {
    this.canLazyLoad() ? this.lazyLoadImage() : this.setPicture();
  }

  private canLazyLoad() {
    return window && 'IntersectionObserver' in window && !this.skipLazyLoading && !this.prioritizeLoading;
  }

  private lazyLoadImage() {
    const obs = new IntersectionObserver(entries => {
      entries.forEach(({ isIntersecting }) => {
        if (isIntersecting) {
          this.setPicture();
          obs.unobserve(this.el.nativeElement);
        }
      });
    });
    obs.observe(this.el.nativeElement);
  }
}
